// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  watcherFireId: __t.u64().primaryKey().name("watcher_fire_id"),
  watcherId: __t.u64().name("watcher_id"),
  workspaceId: __t.u64().name("workspace_id"),
  messageId: __t.u64().name("message_id"),
  fired: __t.bool(),
  decisionReason: __t.string().name("decision_reason"),
  injectedNote: __t.string().name("injected_note"),
  createdAt: __t.i64().name("created_at"),
});
